import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=13a1f4d7&scoped=true&"
import script from "./WidgetFormItem.vue?vue&type=script&lang=ts&"
export * from "./WidgetFormItem.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetFormItem.less?vue&type=style&index=0&id=13a1f4d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1f4d7",
  null
  
)

export default component.exports